<template>
    <div id="tags">
        <div class="input-wrapper tw-flex tw-flex-wrap tw-relative">
            <i class="search-icon far fa-search light-text"></i>
            <div class="background-input" @focus="focusRealInput" :class="{'spoof-active': input_focused}" :placeholder="empty ? placeholder : ''" contenteditable="true"></div>
            <div class="tags-wrapper tw-flex tw-flex-wrap tw-mb-3">
                <span class="tag hover-opacity tw-relative tw-text-sm" @click="removeMember(key)" v-for="(member, key) in members" :key="member.id">
                    <img :src="member.avatar" onerror="this.src='/img/avatar.png'">
                    {{ member.firstname }} {{ member.lastname }}
                    <i class="fal fa-times tw-ml-2 tw-text-xs"></i>
                </span>
                <div :class="[{'has-tags': members.length > 0}]"
                     ref="tagsField"
                     class="tw-relative real-input"
                     contenteditable="true"
                     :placeholder="placeholder"
                     @focus="input_focused = true;"
                     @blur="input_focused = false;"
                     @keydown="keyDown($event)"
                     v-autofocus
                ></div>
            </div>
        </div>

        <!-- mentions -->
        <div class="tributes-wrapper tw-mt-3" ref="tributes" v-show="(input && input.innerText.length > 0) || filteredTributeResults.length > 0 || alreadySelectedResults.length > 0">
            <div class="tribute-container" v-if="filteredTributeResults.length > 0 || alreadySelectedResults.length > 0">
                <ul>
                    <li class="tw-flex tw-items-center normal-text tw-justify-between tw-p-3 tw-rounded tw-cursor-pointer tw-border tw-border-gray-0 tw-mt-2 hover:tw-bg-gray-0" v-for="result in filteredTributeResults" :key="result.id" @click="addMember(result)">
                        <div>
                            <div class="profile-icon-s tw-mr-2">
                                <img :src="result.avatar" onerror="this.src='/img/avatar.png'">
                            </div>
                            {{ result.username }}
                        </div>
                        <!--<span class="light-text tiny-text tw-ml-2">
                            {{ result.username }}
                        </span>-->
                    </li>
                    <li class="tw-flex tw-items-center normal-text tw-justify-between tw-p-3 tw-rounded tw-cursor-pointer tw-border tw-border-gray-0 tw-mt-2 hover:tw-bg-gray-0" v-for="result in alreadySelectedResults" :key="result.id">
                        <div class="tw-flex tw-items-center tw-justify-between tw-w-full">
                            <div class="tw-flex tw-items-center">
                                <div class="profile-icon-s tw-mr-2">
                                    <img :src="result.avatar" onerror="this.src='/img/avatar.png'">
                                </div>
                                <div class="tw-flex tw-flex-col">
                                    {{ result.username }}
                                    <span class="extra-light-text tw-text-xs">already a member or invited</span>
                                </div>
                            </div>
                            <!--<span class="light-text tiny-text tw-ml-2">
                                {{ result.username }}
                            </span>-->
                        </div>
                    </li>
                </ul>
            </div>

            <div class="tw-inline-flex tw-mt-4 tw-mb-3 tw-ml-3" v-if="searching && filteredTributeResults.length === 0">
                <i class="far fa-spinner fa-spin tw-text-xl tw-text-gray-400"></i>
            </div>
            <p class="no-results" v-else-if="filteredTributeResults.length === 0 && alreadySelectedResults.length === 0">
                No (more) results for {{ tribute_query }}
            </p>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import debounce from 'lodash.debounce';
    import Tribute from "tributejs";

    export default {
        name: 'InlineUserSelect',

        props: {
            placeholder: {
                default: false,
            },

            value: {
                default: '',
            },

            selected_users: {
                default: () => [],
            },
            level_user_ids: {
                default: () => [],
            },
        },

        data() {
            return {
                input: false,
                input_focused: false,
                currentValue: '',
                tribute: {},
                tribute_query: '',
                tribute_search_results: [],
                searching: false,
                empty: true,
            };
        },

        computed: {
            members() {
                if (typeof (this.value) === 'object') {
                    const members = [];

                    // eslint-disable-next-line
                    for(let member in this.value) {
                        members.push(this.value[member]);
                    }

                    return members;
                }

                return false;
            },

            filteredTributeResults() {
                return this.tribute_search_results.filter(result => (!this.selected_users.includes(result.id) && !this.level_user_ids.includes(result.id)));
            },

            alreadySelectedResults() {
                return this.tribute_search_results.filter(result => ((this.selected_users.includes(result.id) && !this.selectedMemberIds.includes(result.id) || this.level_user_ids.includes(result.id))));
            },

            selectedMemberIds() {
                return this.value.map(member => member.id);
            },
        },

        methods: {
            addMember(member) {
                const selected_results_ids = this.alreadySelectedResults.map(selected_member => selected_member.id);

                if (!selected_results_ids.includes(member.id)) {
                    if (typeof (this.value) === 'string') {
                        this.value = [];
                    }

                    this.value.push(member);

                    this.updateContent('');

                    this.focusRealInput();
                }
            },

            removeMember(key) {
                this.value.splice(key, 1);
            },

            keyDown(e) {
                if (e.key === 'Enter') {
                    e.preventDefault();
                } else if (e.key === 'Backspace') {
                    if (this.input.innerText.length === 0) {
                        e.preventDefault();

                        this.empty = true;
                        this.removeMember(this.members.length - 1);
                    } else if (this.input.innerText.length === 1) {
                        this.empty = true;
                    }
                } else {
                    this.empty = false;
                }
            },

            updateContent(val) {
                this.input.innerText = val;
            },

            focusRealInput() {
                this.input.focus();

                // eslint-disable-next-line
                let range,selection;

                if (document.createRange) {
                    range = document.createRange(); // Create a range (a range is a like the selection but invisible)
                    range.selectNodeContents(this.input); // Select the entire contents of the element with the range
                    range.collapse(false); // collapse the range to the end point. false means collapse to end rather than the start
                    selection = window.getSelection(); // get the selection object (allows you to change selection)
                    selection.removeAllRanges(); // remove any selections already made
                    selection.addRange(range); // make the range you have just created the visible selection
                } else if (document.selection) {
                    range = document.body.createTextRange(); // Create a range (a range is a like the selection but invisible)
                    range.moveToElementText(this.input); // Select the entire contents of the element with the range
                    range.collapse(false); // collapse the range to the end point. false means collapse to end rather than the start
                    range.select(); // Select the range (make it the visible selection
                }
            },

            searchUsersByTag(query, callback) {
                if (query.length > 1) {
                    this.searching = true;
                    const params = new URLSearchParams();

                    params.append('query', query);
                    params.append('model', 'users');

                    const request = {
                        params,
                    };

                    axios.get('/api/v3/search', request).then((response) => {
                        const users = response.data.results.users.data;
                        this.searching = false;

                        this.tribute_search_results = users;

                        callback(users);
                    });
                }
            },
        },

        mounted() {
            const self = this;
            this.input = this.$refs.tagsField;

            this.tribute = new Tribute({
                autocompleteMode: true,
                allowSpaces: true,
                values: debounce(function (value, cb) {
                    self.tribute_query = self.input.innerText;

                    self.searchUsersByTag(value, users => cb(users));
                }, 150),
                lookup: function (person) {
                    return person.username + person.firstname + person.lastname;
                },
                selectTemplate: function(item) {
                    self.addMember(item.original);

                    return '';
                },
                noMatchTemplate: function () {
                    return '<span style:"visibility: hidden;"></span>';
                },
            });

            this.tribute.attach(this.input);
        },

        created() {
            this.current_value = this.value;
        },

        watch: {
            value(val) {
                if (typeof (this.value) === 'string') {
                    this.updateContent(val);
                }
            },
        },
    };
</script>

<style lang="scss">
    #tags {
        .search-icon {
            @apply tw-absolute tw-z-10;
            right: 16px;
            top: 16px;
        };

        .background-input {
            @apply tw-absolute tw-top-0 tw-w-full tw-h-full tw-rounded;
            min-height: 48px;
            background: #f0f0f1;

            &[contenteditable=true]:empty:before {
                content: attr(placeholder);
                color: #bfbfbf;
                top: 13px;
                position: absolute;
                left: 15px;
            }

            &.spoof-active {
                background: #eaecef;
            }
        }

        .real-input {
            @apply tw-outline-none;
            background: none !important;
            display: inline-block !important;
            width: auto !important;
            padding: 0 !important;
            padding-left: 4px !important;
            padding-right: 15px !important;
            margin-top: 4px !important;
            min-width: 100px;

            &.has-tags {
                padding-left: 6px !important;
                padding-top: 7px !important;

                &[contenteditable=true]:empty:before {
                    content: "" !important;
                }
            }
        }

        .tags-wrapper {
            margin-top: 8px;
            padding-left: 11px;
            padding-right: 15px;
            max-width: 94%;

            .tag {
                @apply tw-flex tw-items-center tw-select-none tw-relative tw-h-auto tw-bg-white;
                margin-top: 5px;
                border-radius: 5px;
                padding-top: 6px;
                padding-bottom: 6px;
                padding-left: 6px;
                padding-right: 9px;
                margin-right: 5px;

                img {
                    @apply tw-rounded-full tw-mr-2;
                    width: 18px;
                    height: 18px;
                }

                &:hover {
                    opacity: 0.7;
                }
            }
        }

        .tributes-wrapper {
            .tribute-container {
                top: auto !important;
                bottom: auto !important;
                left: auto !important;
                position: relative !important;

                .profile-icon-s {
                    img {
                        border-radius: 100%;
                    }
                }
            }

            .no-results {
                @apply tw-font-semibold tw-text-gray-600;
                font-size: 0.925rem !important;
            }
        }
    }
</style>
